import React, { useState, useEffect } from "react";

const ConnectTab = ({ updateChatTabData, chatTabData }) => {
    const [viberNumber, setViberNumber] = useState("");

    useEffect(() => {
        if (chatTabData?.viber_number) {
            setViberNumber(chatTabData.viber_number);
        }
    }, [chatTabData?.viber_number]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setViberNumber(value);
        updateChatTabData("viber_number", value);
    };

    return (
        <div className="whats-app-side-baar-connect-tab">
            <span>Connect</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        value={viberNumber}
                        onChange={handleInputChange}
                        placeholder="Viber Number or Link..."
                    />
                </div>
            </div>
            <p>Example: +15908249465</p>
            <p>Please include country code and do not start with 0 or 00. If you want to link to a Viber bot, provide the specific link to your bot.</p>
        </div>
    );
};

export default ConnectTab;